export default "__VITE_ASSET__nk1hyXck__"